import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import InventoryStructuredTableMode from 'notebook/integrations/samples/InventoryStructuredTableMode';
import useSelectFolderOptionForTable, {
  StructuredTableFolderConfig,
} from 'notebook/structured-tables/components/useSelectFolderOptionForTable';
import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

interface InventoryTableSettingsModalProps {
  insertMode: InventoryStructuredTableMode;
  folderConfig?: StructuredTableFolderConfig;
  locked: boolean;
  onRequestClose: () => void;
  onRequestSubmit: (inventoryTableSettingsValues: InventoryTableSettingsModalValues) => void;
}

export interface InventoryTableSettingsModalValues {
  folderConfig?: StructuredTableFolderConfig;
}

export default function InventoryTableSettingsModal(props: InventoryTableSettingsModalProps): JSX.Element {
  const {selectedFolderConfig, isInvalidFolderConfig, folderOptionSelector} = useSelectFolderOptionForTable({
    initialFolderConfig: props.folderConfig,
    itemTypeSupportsFolders: false,
    isReadOnly: props.locked,
    isForCreate: props.insertMode === InventoryStructuredTableMode.CREATE,
    projectIsRequired: BenchlingConfig.ENABLE_PROJECTS_REQUIRED_FOR_NON_LOCATION_STORABLES,
  });

  const handleRequestSubmit = (): void => {
    if (props.folderConfig != null) {
      props.onRequestSubmit({folderConfig: selectedFolderConfig});
    }
  };

  return (
    <Modal
      title="Inventory table settings"
      onRequestClose={props.onRequestClose}
      onRequestSubmit={handleRequestSubmit}
      buttons={[
        {
          text: 'Save',
          disabled: props.locked || isInvalidFolderConfig,
          style: ButtonStyle.SECONDARY,
          submit: true,
        },
        {text: 'Cancel', cancel: true},
      ]}
    >
      {props.folderConfig != null && folderOptionSelector}
    </Modal>
  );
}
